import {
  USER_MODIFY_BEGIN,
  USER_MODIFY_SUCCESS,
  USER_MODIFY_ERROR,
  USER_MODIFY_RESET,
} from 'action-creators/user/modify/constants';

const initialState = {
  userModify: {
    payload: {},
    loading: false,
    error: false,
  },
};

const userModifyReducer = (state = initialState.userModify, action) => {
  if (action.type === USER_MODIFY_BEGIN) {
    return {
      ...initialState.userModify,
      loading: true,
    };
  }
  if (action.type === USER_MODIFY_SUCCESS) {
    const { payload } = action;
    return {
      ...initialState.userModify,
      payload,
    };
  }
  if (action.type === USER_MODIFY_ERROR) {
    return {
      ...initialState.userModify,
      error: {
        ...action.payload,
      },
    };
  }
  if (action.type === USER_MODIFY_RESET) {
    return initialState;
  }
  return state;
};

export default userModifyReducer;
